import React, { useEffect, useRef, useState } from 'react'
import cx from "clsx"
import '../../../design/custom.scss';

// Simple Collapse component to replace @kunukn/react-collapse
const Collapse = ({ isOpen, children, style }) => {
    const contentRef = useRef(null);
    const [height, setHeight] = useState(0);

    useEffect(() => {
        if (contentRef.current) {
            setHeight(isOpen ? contentRef.current.scrollHeight : 0);
        }
    }, [isOpen, children]);

    return (
        <div
            style={{
                overflow: isOpen ? (style?.overflow || 'hidden') : 'hidden',
                transition: `height ${style?.transitionDuration || '300ms'} cubic-bezier(0.4, 0, 0.2, 1), visibility ${style?.transitionDuration || '300ms'}`,
                height: isOpen ? height : 0,
                visibility: isOpen ? 'visible' : 'hidden',
            }}
        >
            <div ref={contentRef}>
                {children}
            </div>
        </div>
    );
};

const AccordionHeader = ({
    heading,
    secondaryHeading,
    headingRight,
    setIsOpen,
    isOpen,
    transitionDuration,
    quantityChanged,
    setQuantityChanged,
    currentIndex,
    sameItemIndex,
}) => {

    React.useEffect(()=>{
        if(quantityChanged){
            setTimeout(()=>{
                setQuantityChanged(false)
            },[300])
        }
    },[quantityChanged])

    const buttonStyle = {
        border: 'none',
        display: 'flex',
        alignItems: 'center',
        fontSize: '100%',
        margin: 0,
        padding: '20px',
        paddingTop: secondaryHeading ? '9px' : '20px',
        paddingBottom: secondaryHeading ? '9px' : '20px',
        minHeight: isOpen ? '80px' : '60px',
        position: 'relative',
        width: '100%',
        textAlign: 'left',
        background: 'white',
        fontFamily: 'inherit',
        outline: 'none',
        cursor: 'pointer'
    };

    return (
        <button
            aria-expanded={isOpen}
            onClick={() => {
                setIsOpen(!isOpen)
            }}
            className="accordion__toggle"
            style={buttonStyle}
        >
            <div style={{ flex: 1 }}>
                <span style={{
                    display: 'block',
                    lineHeight: 1.25,
                    fontSize: '16px',
                    fontWeight: 'bold'
                }}>
                    {heading}
                </span>
                {secondaryHeading && (
                    <span style={{
                        marginTop: '2px',
                        display: 'block',
                        lineHeight: 1.25,
                        fontSize: '16px'
                    }}>
                        {secondaryHeading}
                    </span>
                )}
            </div>
            {headingRight && (
                <span
                    className={quantityChanged && currentIndex==sameItemIndex?"quantity-changed-enter-active":!quantityChanged && currentIndex==sameItemIndex?"quantity-changed-exit-active":""}
                    style={{
                        marginTop: '2px',
                        display: 'block',
                        lineHeight: 1.25,
                        fontSize: '16px',
                        color: '#007567'
                    }}
                >
                    {headingRight}
                </span>
            )}
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 32 32"
                style={{
                    color: '#007567',
                    marginLeft: '15px',
                    width: '20px',
                    height: '20px',
                    transition: `transform ${transitionDuration} cubic-bezier(0, 1, 0, 1)`,
                    transform: isOpen ? 'rotate(.5turn)' : 'rotate(0)'
                }}
            >
                <path
                    fill="currentColor"
                    d="M29.602 8.002l-13.6 11.562-13.6-11.562-2.4 2.752 16 13.764 16-13.764z"
                />
            </svg>
            <div
                className="accordion__divider"
                style={{
                    position: 'absolute',
                    top: '0px',
                    height: '1px',
                    left: '20px',
                    right: '20px',
                    background: '#e4e5e4',
                    transition: '260ms',
                    display: 'block'
                }}
            />
        </button>
    );
};

const Accordion = ({
    openAccordion,
    children,
    heading,
    secondaryHeading,
    headingRight,
    transitionDuration,
    quantityChanged,
    setQuantityChanged,
    currentIndex,
    sameItemIndex,
    overflow,
    marginBottom="40px",
    padding="1px"
}) => {

    const [isOpen, setIsOpen] = React.useState(false)

    useEffect(() => {
        setIsOpen(openAccordion)
    }, [openAccordion])

    return (
        <div
            className={cx("accordion", {
                "accordion--is-open": isOpen,
                "accordion--is-closed": !isOpen
            })}
            style={{
                position: 'relative',
                transition: transitionDuration
            }}
        >
            <AccordionHeader
                {...{
                    heading,
                    secondaryHeading,
                    headingRight,
                    transitionDuration,
                    setIsOpen,
                    isOpen,
                    quantityChanged,
                    setQuantityChanged,
                    currentIndex,
                    sameItemIndex,
                    marginBottom,
                    padding
                }}
            />
            <Collapse
                isOpen={isOpen}
                style={{ transitionDuration, overflow: overflow ? "visible" : "hidden" }}
                aria-hidden={isOpen ? "false" : "true"}
            >
                <div style={{ marginBottom: marginBottom, padding: padding }}>
                    {children}
                </div>
            </Collapse>
        </div>
    );
};

export default Accordion;
